"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionStatus = void 0;
var classnames_1 = require("classnames");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var admin_1 = require("../../../../services/page/admin");
var styles = require("./index.scss");
var TimeReduce_1 = require("./TimeReduce");
var SessionStatus;
(function (SessionStatus) {
    SessionStatus["REMAINING"] = "Remaining";
    SessionStatus["COMING_SOON"] = "Coming Soon";
    SessionStatus["TOMORROW"] = "Tomorrow";
})(SessionStatus = exports.SessionStatus || (exports.SessionStatus = {}));
var ProductSession = (function (_super) {
    __extends(ProductSession, _super);
    function ProductSession(props) {
        var _this = _super.call(this, props) || this;
        _this.onScroll = function () {
            var stickToTop = _this.props.stickToTop;
            var navToTop = _this.navWrapRef.getBoundingClientRect().top;
            var parentNode = _this.navWrapRef.parentNode;
            var parentToBottom = parentNode.getBoundingClientRect().bottom;
            if (_this.state.fixed) {
                if (_this.placeholderRef.getBoundingClientRect().top >= stickToTop ||
                    parentToBottom <= stickToTop) {
                    _this.setState({ fixed: false });
                }
                return;
            }
            if (navToTop <= stickToTop && parentToBottom > stickToTop) {
                _this.setState({ fixed: true });
            }
        };
        _this.handelClickItem = function (item, index) { return function () {
            if (index !== _this.props.selectedIndex) {
                _this.props.onChange(item, index, _this.state.fixed);
            }
        }; };
        _this.getSettingStatus = function (state) {
            switch (state) {
                case admin_1.TActState.OnGoing:
                    return SessionStatus.REMAINING;
                case admin_1.TActState.ComingSoon:
                    return SessionStatus.COMING_SOON;
                default:
                    return SessionStatus.COMING_SOON;
            }
        };
        _this.state = {
            fixed: false
        };
        _this.navWrapRef = null;
        _this.placeholderRef = null;
        return _this;
    }
    ProductSession.prototype.componentDidMount = function () {
        var stick = this.props.stick;
        if (stick) {
            window.addEventListener("scroll", this.onScroll);
        }
    };
    ProductSession.prototype.componentWillUnmount = function () {
        window.removeEventListener("scroll", this.onScroll);
    };
    ProductSession.prototype.render = function () {
        var _a, _b, _c, _d;
        var _this = this;
        var _e = this.props, sessions = _e.sessions, style = _e.style, className = _e.className, stickToTop = _e.stickToTop, currentPosition = _e.currentPosition, selectedIndex = _e.selectedIndex, onChangePosition = _e.onChangePosition;
        var fixed = this.state.fixed;
        return [
            React.createElement("div", { key: "placeholder", ref: function (element) { return (_this.placeholderRef = element); }, className: classnames_1.default(styles.sessionWrapper, className), style: __assign({
                    display: fixed ? "block" : "none",
                    marginTop: 12
                }, style) }),
            React.createElement("div", { key: "category", style: { top: fixed ? stickToTop : "", display: sessions.length < 1 ? "none" : "" }, className: classnames_1.default(styles.sessionWrapper, (_a = {},
                    _a[styles.fixed] = fixed,
                    _a)), ref: function (element) { return (_this.navWrapRef = element); } },
                React.createElement("div", { className: classnames_1.default(styles.session, (_b = {}, _b[styles.showController] = sessions.length > 4, _b)) },
                    React.createElement("i", { className: classnames_1.default((_c = {}, _c[styles.arrowDisabled] = currentPosition === 0, _c)), onClick: function () { return onChangePosition("previous"); } }),
                    React.createElement("ul", null, sessions.map(function (item, index) {
                        var _a;
                        var statusText = _this.getSettingStatus(item.state);
                        return (React.createElement("li", { key: index, className: classnames_1.default((_a = {}, _a[styles.active] = index === selectedIndex, _a)), onClick: _this.handelClickItem(item, index), style: { transform: "translateX(" + -currentPosition * 280 + "px)" } },
                            React.createElement("div", null,
                                React.createElement("h1", null, item.flashName),
                                React.createElement("b", null,
                                    React.createElement("span", null,
                                        statusText,
                                        " "),
                                    item.state === admin_1.TActState.OnGoing && (React.createElement(TimeReduce_1.default, { className: styles.reduceTime, time: parseInt(item.endSpan, 10) }))))));
                    })),
                    React.createElement("i", { className: classnames_1.default((_d = {}, _d[styles.arrowDisabled] = currentPosition + 4 >= sessions.length, _d)), onClick: function () { return onChangePosition("next"); } })))
        ];
    };
    ProductSession.defaultProps = {
        stick: true,
        stickToTop: 0
    };
    ProductSession = __decorate([
        mobx_react_1.observer
    ], ProductSession);
    return ProductSession;
}(React.Component));
exports.default = ProductSession;
